import { useState } from "react";

import { useTranslation } from "react-i18next";

import Autocomplete from "components/DesignComponents/Autocomplete";
import HighlightedOption from "components/HighlightedOption";
import { getVehicle, sortAndReturnArray } from "shared/functions";
import { DROPDOWN_SIZES } from "shared/types/enums";

import { ModelsProps, VehicleInfo } from "./types";

const Models = ({ data, value, isLoading, change }: ModelsProps) => {
    const { t } = useTranslation();

    const [inputValue, setInputValue] = useState("");

    const sortedData = sortAndReturnArray(data, "model");

    const renderVehicleOption = (option: VehicleInfo) =>
        getVehicle({
            model: option.model,
            startYear: option.year_start,
            endYear: option.year_end
        });

    return (
        <Autocomplete
            fullWidth
            isRequired
            size={DROPDOWN_SIZES.Medium}
            labelLeft={t("Dialog##vehicle model")}
            textFieldParams={{
                placeholder: t("Dialog##select")
            }}
            options={sortedData}
            value={value}
            getOptionLabel={(option: VehicleInfo) =>
                renderVehicleOption(option)
            }
            renderOption={(props, option: VehicleInfo) => (
                <li {...props} key={option.vehicle_id}>
                    <span>
                        <HighlightedOption
                            text={renderVehicleOption(option)}
                            query={inputValue}
                        />
                    </span>
                </li>
            )}
            readOnly={isLoading}
            onInputChange={(_, newInputValue) => setInputValue(newInputValue)}
            onChange={(_, value) => change(value)}
            customStyle={{
                marginTop: "16px"
            }}
        />
    );
};

export default Models;
